export default __webpack_public_path__ + "static/media/gpsIcon.623ba282.png";